/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_b98aaf81{display:block;position:relative}.measured_b98aaf81{position:fixed;visibility:hidden}\n"}]);
export const root = "root_b98aaf81";
export const measured = "measured_b98aaf81";